import React, { useState } from "react";
import { message, Pagination, Select, Table } from "antd";
import Button from "../../common/Button";
import {
  useApproveRequest,
  useInboxRequests,
  useRejectRequest,
} from "../../hooks/useRequests";
import "./style.scss";

const STAGE_OPTIONS = [
  { value: "Approval Pending", label: "Approval Pending" },
  { value: "Under Review", label: "Under Review" },
  { value: "Pending", label: "Pending" },
  { value: "Rejected", label: "Rejected" },
  { value: "Processing", label: "Processing" },
  { value: "Successfully Processed.", label: "Successfully Processed" },
  { value: "Request Failed", label: "Request Failed" },
];

const actionError = (err) =>
  err?.response?.data?.message || err?.message || "Please try again later.";

const RequestInbox = () => {
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [stage, setStage] = useState("Approval Pending");

  const { data, isLoading, refetch } = useInboxRequests({
    pageNum,
    pageSize,
    stage,
  });
  const requests = data?.requests || [];
  const totalCount = data?.totalCount || 0;

  const { mutate: approve, isLoading: isApproving } = useApproveRequest(
    () => {
      message.success("Request approved");
      refetch();
    },
    (err) => message.error(actionError(err))
  );
  const { mutate: reject, isLoading: isRejecting } = useRejectRequest(
    () => {
      message.success("Request rejected");
      refetch();
    },
    (err) => message.error(actionError(err))
  );

  const onPageChange = (page, size) => {
    if (page !== pageNum) {
      setPageNum(page);
    } else {
      setPageSize(size);
      setPageNum(1);
    }
  };

  const canAct = stage === "Approval Pending";

  const columns = [
    {
      title: "Type",
      key: "requestType",
      align: "center",
      dataIndex: "requestType",
    },
    {
      title: "SKU ID",
      key: "skuId",
      align: "center",
      render: (_, record) => record?.requestData?.skuId || "-",
    },
    {
      title: "Name",
      key: "userName",
      align: "center",
      render: (_, record) => <div>{record?.raisedBy?.userName}</div>,
    },
    {
      title: "Email",
      key: "userEmail",
      align: "center",
      render: (_, record) => <div>{record?.raisedBy?.userEmail}</div>,
    },
    {
      title: "Comment",
      key: "comment",
      align: "center",
      dataIndex: "comment",
    },
    {
      title: "Attachment",
      key: "attachments",
      align: "center",
      render: (_, record) => {
        const attachments = record?.attachments || [];
        if (!attachments.length) return "-";
        return (
          <div className="attachment_links">
            {attachments.map((file, index) => (
              <a
                key={file?.key || index}
                href={file?.url}
                target="_blank"
                rel="noreferrer"
              >
                File {index + 1}
              </a>
            ))}
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) =>
        canAct ? (
          <div className="action_btns">
            <Button
              text="Approve"
              width="100px"
              height="40px"
              isDisabled={isApproving || isRejecting}
              handleClick={() => approve(record?._id)}
            />
            <Button
              text="Reject"
              width="100px"
              height="40px"
              isDisabled={isApproving || isRejecting}
              handleClick={() => reject(record?._id)}
            />
          </div>
        ) : (
          <div>{record?.stage}</div>
        ),
    },
  ];

  return (
    <div className="request_inbox">
      <div className="inbox_header">
        <h1>Requests</h1>
        <div className="stage_filter">
          <label>Stage</label>
          <Select
            options={STAGE_OPTIONS}
            value={stage}
            onChange={(value) => {
              setStage(value);
              setPageNum(1);
            }}
            style={{ minWidth: 220 }}
          />
        </div>
      </div>
      <div className="table_content_wrapper">
        <Table
          columns={columns}
          dataSource={requests}
          rowKey="_id"
          loading={isLoading}
          scroll={{ y: `calc(70vh - 30px)` }}
          className="main_table"
          pagination={false}
        />
      </div>
      <div className="pagination_wrapper">
        <Pagination
          total={totalCount}
          showTotal={false}
          current={pageNum}
          pageSize={pageSize}
          onChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default RequestInbox;
